import { SortedAndPaginatedRequest } from '../requestModels/sortedAndPaginatedRequest';
import { Contract } from '../types/Contract';
import { PaginatedResult } from '../types/PaginatedResult';
import { httpDelete, httpGet, httpPost } from './api.service';

const getContracts = async (request: SortedAndPaginatedRequest): Promise<PaginatedResult<Contract>> => {
  return await httpGet<PaginatedResult<Contract>>(`api/contract`, request);
};

const upsertContract = async (contract: Contract): Promise<any> => {
  return await httpPost<Contract>(`api/contract`, contract);
};

const deleteContract = async (id: string): Promise<any> => {
  return await httpDelete(`api/contract/${id}`);
};

export { getContracts, upsertContract, deleteContract };
